import styled from "styled-components";

export const PageContainer = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 1rem;
`;

export const Header = styled.div`
  margin-bottom: 1.25rem;

  h1 {
    margin: 0;
    font-size: 2rem;
    color: var(--text-main);
  }

  p {
    margin: 0.45rem 0 0;
    color: var(--text-secondary);
  }
`;

export const Card = styled.section`
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 14px;
  padding: 1rem;
  margin-bottom: 1rem;
`;

export const CardTitle = styled.h2`
  margin: 0 0 0.9rem;
  font-size: 1.15rem;
  color: var(--text-main);
`;

export const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.8rem;

  @media (max-width: 840px) {
    grid-template-columns: 1fr;
  }
`;

export const SummaryCard = styled.div`
  border: 1px solid var(--border-color);
  background: var(--bg-main);
  border-radius: 10px;
  padding: 0.8rem;

  h3 {
    margin: 0;
    color: var(--text-secondary);
    font-size: 0.85rem;
    font-weight: 600;
  }

  p {
    margin: 0.3rem 0 0;
    color: var(--text-main);
    font-size: 1.2rem;
    font-weight: 800;
  }
`;

export const TableWrap = styled.div`
  width: 100%;
  overflow-x: auto;

  table {
    width: 100%;
    border-collapse: collapse;
    min-width: 620px;
  }

  th,
  td {
    text-align: left;
    padding: 0.65rem;
    border-bottom: 1px solid var(--border-color);
    color: var(--text-main);
    font-size: 0.9rem;
  }

  th {
    color: var(--text-secondary);
    font-weight: 700;
  }
`;

export const SecondaryButton = styled.button`
  background: transparent;
  color: var(--text-main);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 0.45rem 0.7rem;
  cursor: pointer;
`;

export const EmptyState = styled.p`
  color: var(--text-secondary);
  margin: 0.5rem 0 0;
`;